import { type MutableRefObject, type RefCallback,useEffect, useRef } from 'react';

type Ref<T> = MutableRefObject<T> | RefCallback<T> | null;

const useCombinedRefs = <T extends HTMLElement | null>(
  ...refs: (Ref<T> | undefined)[]
): MutableRefObject<T | null> => {
  const targetRef = useRef<T | null>(null);

  useEffect(() => {
    refs.forEach((ref) => {
      if (!ref) return;

      if (typeof ref === 'function') {
        ref(targetRef.current);
      } else {
        (ref as MutableRefObject<T | null>).current = targetRef.current;
      }
    });
  }, [refs]);

  return targetRef;
};

export default useCombinedRefs;
